import { useTranslation } from "react-i18next";
import { Breadcrumb, Button, Col, Form, Input, List, Radio, Row, Steps, message } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { _adr } from "../../../../address";
import { Content } from "antd/es/layout/layout";
import "../sp.scss";
import "./msisdn.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { complexDigitToman, convertPersian, isEmpty } from "../../../../tools/tools";
import { MaskedInput } from "antd-mask-input";
import { useDealer } from "../../../../tools/api";
import React, { createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import { NotFound } from "../../../../sources/svg/svg";
import SPShopLayout from "../sp-shop-layout";
import { switchPlanID } from "../../../../tools/services";
const SPMsisdn = () => {
	// #region Construct
	const [t] = useTranslation("global");
	const location = useLocation();
	const nav = useNavigate();
	const [frmNumber] = Form.useForm();
	const { queryMSISDNByBundleSalesSimId, reserveKitNo, reserveMSISDN } = useDealer();
	const [messageApi, contextHolder] = message.useMessage();
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	// #endregion

	// #region state management
	// props state
	const { kit, bundle, msisdn, iccid } = location?.state || {};
	//state for list msisdn
	const [msisdnList, setMsisdnList] = useState([]);
	//state select msisdn
	const [selectedMsisdn, setSelectedMsisdn] = useState(0);
	// state totalRecord msisdn
	const [totalRecord, setTotalRecord] = useState(0);
	//state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	//state loading Msisdn Records
	const [isLoadingMsisdn, setIsLoadingMsisdn] = useState(true);

	//previous value search
	const [searchPrv, setSearchPrv] = useState("");

	//entery MSISDN
	const [msisdnEntry, setMsisdnEntry] = useState(["", "", "", "", "", "", ""]);
	// #region state management

	const inputRefs = Array(7)
		.fill(0)
		.map(() => createRef());

	useEffect(() => {
		searchMsisdn();
	}, [currentPage]);

	//handle Input Events & Cancel Status =================
	const handleInputChange = (e, index) => {
		const newValue = e.target.value;
		if (/^[0-9]*$/.test(newValue)) {
			const newOTP = [...msisdnEntry];
			newOTP[index] = newValue;
			setMsisdnEntry(newOTP);

			if (index < 5 && newValue !== "") {
				inputRefs[index + 1].current.focus();
			}
		}
	};

	const handleInputBackspace = (e, index) => {
		if (e.keyCode === 8 && index > 0 && msisdnEntry[index] === "") {
			const newOTP = [...msisdnEntry];
			newOTP[index - 1] = "";
			setMsisdnEntry(newOTP);
			// اگر عدد حذف شود، فوکوس به ورودی قبلی منتقل می‌شود
			inputRefs[index - 1].current.focus();
		}
	};

	const handleChangeFilter = () => {
		let optValue = inputRefs.map((ref) => ref?.current?.input?.value);

		// let msisdn = e.target.value.replace(/\D/g, "").slice(3);
		if (searchPrv !== msisdn) {
			const _msisdn = optValue.map((item) => (item === "" ? "*" : item)).join("");

			setSearchPrv(_msisdn);
			// switch (msisdn.length) {
			//   case 1:
			//     msisdn += "******";
			//     break;
			//   case 2:
			//     msisdn += "*****";
			//     break;
			//   case 3:
			//     msisdn += "****";
			//     break;
			//   case 4:
			//     msisdn += "***";
			//     break;
			//   case 5:
			//     msisdn += "**";
			//     break;
			//   case 6:
			//     msisdn += "*";
			//     break;
			//   default:
			//     break;
			// }
			searchMsisdn(_msisdn);
		}
	};

	const searchMsisdn = async (filter = "*******") => {
		setIsLoadingMsisdn(true);
		let payload = {
			searchconfigmodel: {
				sort: "",
				filter: filter,
				entriesperpage: 10,
				page: currentPage,
				totalrowcount: totalRecord,
			},
			planid: switchPlanID().simPurchase,
			bundlesalessimid: bundle.bundleSalesSimId,
		};
		let response = await queryMSISDNByBundleSalesSimId(payload);
		if (response) {
			setMsisdnList(response.Result);
			setTotalRecord(response.searchconfigmodel.totalrowcount);
		}
		setIsLoadingMsisdn(false);
	};
	const handleSubmit = async () => {
		try {
			let _temp = "";
			if (await reservKit(kit)) {
				if (msisdn.length > 0) {
					if (await reservMsisdn(msisdn)) {
						_temp = msisdn.map((item) => {
							return { msisdn: item, isgift: bundle?.bundleSalesSimGiftId?.toString()?.length > 0 ? true : false };
						});
						dispatch(simcardPurchase({ spPurchase: { spMsisdn: _temp, spKit: kit, spbundle: { ...bundle, iccid: iccid } } }));
						nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Profile);
					}
				} else {
					if (selectedMsisdn?.toString().length > 0) {
						if (await reservMsisdn([selectedMsisdn])) {
							_temp = [selectedMsisdn].map((item) => {
								return { msisdn: item, isgift: bundle?.bundleSalesSimGiftId?.toString()?.length > 0 ? true : false };
							});
							dispatch(simcardPurchase({ spPurchase: { spMsisdn: _temp, spKit: kit, spbundle: { ...bundle, iccid: iccid } } }));
							nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Profile);
						}
					} else {
						messageApi.open({
							type: "error",
							content: t("simcardpurchase.msisdn.emptyMsisdn"),
						});
						return;
					}
				}
			}
		} catch (error) {}
	};

	const reservMsisdn = async (list) => {
		const promise = list.map(async (item) => {
			let payMsisdn = {
				msisdn: item,
			};
			let resMsisdn = await reserveMSISDN(payMsisdn);
			if (resMsisdn) {
				return { success: true };
			} else {
				return { success: false };
			}
		});
		let result = await Promise.all(promise);
		if (result.every((res) => res.success)) {
			return true;
		} else {
			return false;
		}
	};
	const reservKit = async (kit) => {
		return new Promise(async (resolve, reject) => {
			let payKit = {
				KitNo: kit,
			};
			let resKit = await reserveKitNo(payKit);
			if (resKit) {
				resolve(true);
			} else {
				reject(false);
			}
		});
	};
	return (
		<>
			<SPShopLayout>
				{contextHolder}
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.global.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.global.title")}</h3>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={1}
											items={[
												{
													title: "بسته آغازین",
												},
												{
													title: "انتخاب شماره",
												},
												{
													title: "اطلاعات هویتی",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "سند",
												},
											]}
										/>
									</div>
								</div>
								<div className="msisdn-container">
									<div className="pickup-kit">
										<p>
											شماره کیت وارد شده <span dir="ltr">{iccid}</span> می‌باشد
										</p>
									</div>
									<div className="g-list-bundle">
										<div className="item">
											<div className="row-item">
												<div className="title-sim">
													<h3>{bundle?.bundleName}</h3>
													{!isEmpty(bundle?.bundleSalesSimGiftId) && (
														<div className="gift">
															<div className="hold-gift">
																<i className="icon-gift"></i>
															</div>
															<span>همراه با سیم کارت هدیه</span>
														</div>
													)}
												</div>
												<div className="hold-desc">
													<h3>{bundle?.attributeDescription}</h3>
													<p>
														{bundle.attribute.map((attr, key) => (
															<React.Fragment key={key}>{attr.briefDescription + " "} </React.Fragment>
														))}
													</p>
												</div>
												<div className="hold-price">
													<span>
														<span dir="ltr">{complexDigitToman(bundle?.bundlePrice)}</span> تومان
													</span>
												</div>
												<div className="hold-aciton">
													<Button
														className="btn-package"
														data-object={JSON.stringify(bundle)}
														onClick={() => {
															nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit, {
																state: {
																	kit: kit,
																},
															});
														}}>
														{t("simcardpurchase.msisdn.changePackage")}
													</Button>
												</div>
											</div>
										</div>
									</div>
									<div className="selected-msisdn">
										{msisdn?.length > 0 && (
											<div className="pickup-kit">
												<p>
													شماره سیم کارت انتخاب شده{" "}
													{msisdn.map((item, key) =>
														key === 0 ? (
															<span key={key} dir="ltr">
																{" "}
																{item}{" "}
															</span>
														) : (
															<span key={key} dir="ltr">
																{", "}
																{item}
															</span>
														),
													)}{" "}
													می‌باشد
												</p>
											</div>
										)}
									</div>
									{msisdn.length === 0 && (
										<div className="holder-search-area">
											<Row>
												<Col xl={15} lg={15} md={24}>
													<h3>لطفا شماره مورد نظر خود را انتخاب کنید. </h3>
													<Form name="frm_SeachMsisdn" className="searchbox" layout="vertical" onFinish={() => {}}>
														<Row dir="ltr">
															<Col xxl={12}>
																<Row>
																	<Col>
																		<div className="holder-prefix">
																			<h3>0999</h3>
																		</div>
																	</Col>
																	<Col>
																		<Form.Item name="msisdn" className="input-normal">
																			{msisdnEntry.map((value, index) => (
																				<Input
																					key={index}
																					autoComplete="off"
																					name={`msisdn[${index}]`}
																					ref={inputRefs[index]}
																					value={value}
																					onChange={(e) => {
																						e.target.value = convertPersian(e.target.value);
																						handleInputChange(e, index);
																					}}
																					onKeyDown={(e) => handleInputBackspace(e, index)}
																					maxLength={1}
																				/>
																			))}
																			{/* <MaskedInput
                                className="searchMsisdn"
                                onKeyUp={handleChangeFilter}
                                suffix={<i style={{ fontSize: "24px" }} className="icon-search"></i>}
                                dir="ltr"
                                mask="9991 00 00 00"
                              /> */}
																		</Form.Item>
																	</Col>
																</Row>
															</Col>
															<Col xxl={12}>
																<Form.Item>
																	<div className="holder-button">
																		<Button className="btn-normal btn-green" onClick={handleChangeFilter}>
																			جستجو
																		</Button>
																	</div>
																</Form.Item>
															</Col>
														</Row>
													</Form>
													<Form form={frmNumber}>
														<Form.Item
															className="input-normal"
															required={[
																{
																	require: true,
																},
															]}>
															<List
																itemLayout="horizontal"
																size="large"
																dataSource={msisdnList}
																pagination={{
																	className: "page-pagination",
																	onChange: (page) => {
																		setCurrentPage(page);
																	},
																	pageSize: 10,
																	align: "start",
																	current: currentPage === 0 ? 1 : currentPage,
																	total: totalRecord,
																	showSizeChanger: false,
																}}
																className="show-list"
																loading={isLoadingMsisdn}
																locale={{ emptyText: <NotFound text={""} /> }}
																renderItem={(item) => (
																	<List.Item key={item.msisdnId}>
																		<Radio.Group
																			onChange={(e) => {
																				setSelectedMsisdn(e.target.value);
																			}}
																			value={selectedMsisdn}
																			className="radio-list">
																			<Radio className="radio-msisdn" value={item.msisdn}>
																				{item.msisdn}
																			</Radio>
																		</Radio.Group>
																	</List.Item>
																)}
															/>
														</Form.Item>
													</Form>
												</Col>
											</Row>
										</div>
									)}
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
										مرحله بعد
									</Button>
									<Button
										type="default"
										className="btn-normal"
										onClick={() => {
											nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit, {
												state: {
													kit: kit,
												},
											});
										}}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</SPShopLayout>
		</>
	);
};

export default SPMsisdn;
